import Vue from 'vue';
import Vuetify from 'vuetify/lib';
import {Ripple} from 'vuetify/lib/directives';
import 'material-design-icons-iconfont/dist/material-design-icons.css';

Vue.use(Vuetify, {
  directives: {
    Ripple,
  },
});

export default new Vuetify({
  icons: {
    iconfont: 'md',
  },
});
